// extracted by mini-css-extract-plugin
module.exports = {"announcementPanel":"AnnouncementPanel_announcementPanel__S1rqu","deleteButton":"AnnouncementPanel_deleteButton__hNGFA"};